import { createFileRoute } from "@tanstack/react-router";

import Administration from "~/pages/Administration";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration")({
  staticData: ROUTE_STATIC.administration,
  component: Administration,
});
